import type { oz } from '@weft/utils';
import { UserInputBillingIntervalSchema } from '../../primitives';
import { UsageProductInputSchema } from './product-input-schemas';

export const PlanInputFormUsageProductSchema = UsageProductInputSchema.extend({
  billingInterval: UserInputBillingIntervalSchema,
});

export type PlanInputFormUsageProduct = oz.infer<typeof PlanInputFormUsageProductSchema>;